import getDateDifference from 'utils/date/getDateDifference';
import isSameMonth from 'utils/date/isSameMonth';
import { stripTime } from 'utils/date/stripTime';

const groupEventDatesByProximity = (
  dates: (Date | string)[] | null,
  maxDaysDiffToGroup: number,
): Date[][] => {
  if (!dates || dates.length === 0) return [];
  const today = stripTime(new Date());
  const oneDayMs = 24 * 60 * 60 * 1000;

  const sortedDates = dates
    .map((dateStr) => stripTime(new Date(dateStr)))
    .filter((date) => date.getTime() + oneDayMs >= today.getTime())
    .sort((a, b) => a.getTime() - b.getTime());

  return sortedDates.reduce<Date[][]>((groupedDates, currentDate) => {
    // If no groups yet, start with the first date
    if (!groupedDates.length) {
      groupedDates.push([currentDate]);
      return groupedDates;
    }

    const lastDateInGroup = groupedDates[groupedDates.length - 1].slice(-1)[0];
    const daysApart = getDateDifference(currentDate, lastDateInGroup);
    const sameMonth = isSameMonth(currentDate, lastDateInGroup);

    // Group dates that are close enough and in the same month
    if (daysApart <= maxDaysDiffToGroup && sameMonth) {
      groupedDates[groupedDates.length - 1].push(currentDate);
    } else {
      groupedDates.push([currentDate]);
    }

    return groupedDates;
  }, []);
};

export default groupEventDatesByProximity;
